import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Input } from 'semantic-ui-react'
import CommentActions from 'Redux/CommentRedux'

class SearchComments extends Component {
  handleChange = (e) => {
    if (!e.target.value) {
      // if search term is empty
      this.props.commentsListRequest(this.props.videoId)
    } else {
      this.props.commentsSearchRequest(e.target.value)
    }
  }

  render () {
    return (
      <Input
        loading={this.props.fetching}
        icon='search'
        placeholder='Search keyword...'
        onChange={this.handleChange}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  fetching: state.comments.searchFetching
})

const mapDispatchToProps = (dispatch) => ({
  commentsListRequest: (videoId) =>
    dispatch(CommentActions.commentsListRequest(videoId)),
  commentsSearchRequest: (text) =>
    dispatch(CommentActions.commentsSearchRequest(text)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchComments)



// WEBPACK FOOTER //
// ./src/Components/Comments/SearchComments.js